// extracted by mini-css-extract-plugin
export default {"container":"AngloAmericanIct_container__T2Rhn","heading":"AngloAmericanIct_heading__il2cW","date":"AngloAmericanIct_date__KZsWB","content":"AngloAmericanIct_content__mensX"};